import {Breakpoints, styled} from '@volkswagen-onehub/components-core';
import React, { useContext } from 'react';
import {CustomTag} from '../../CustomTag';
import CpoTag from '../CpoTag';
import {getEVIncentives} from '../../../utils/get-ev-incentives';
import { ResultsView, ResultsViewContext } from '../../../utils/results-view-context';
import { VehicleCategory } from '../../../types/enums/vehicles';
import { VehicleData } from '../../../types';

interface CardIncentivesInterface {
  vehicle: VehicleData;
}

interface CardIncentivesContainerInterface {
  view: ResultsView;
  certified: boolean;
  hasIncentives: boolean;
  color?: string;
}

const CardIncentivesContainer = styled.div<CardIncentivesContainerInterface>`
  height: 100%;
  grid-area: incentives;
  text-align: center;
  width: 100%;
  background-color: rgb(238, 238, 238);
  background-color: ${props => props.certified || props.hasIncentives ? (props.certified ? '#00b0f0' : '#d9e6ff') : 'rgb(238, 238, 238)'};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  min-height: 40px;
  height: 100%;


  ${props => !props.hasIncentives && !props.certified && `
    @media screen and (min-width: ${Breakpoints.b960}px) {
      display: block;
    }
  `}

  p {
    width: 100%;
    padding: ${(props) => props.theme.size.dynamic0020};
    line-height: 100%;
  }
`;

const CardIncentives: React.FC<CardIncentivesInterface> = ({vehicle}) => {
  const incentives = getEVIncentives(vehicle);
  const view = useContext(ResultsViewContext).value;

  const getCustomTags = () => {

    if (vehicle.category == VehicleCategory.CERTIFIED) {
      return <CpoTag />;
    }

    if (!incentives.count) {
      return null;
    } else {
      const text = incentives?.label?.replace('%%total%%', incentives.total);
      return <CustomTag text={text} bgColor="#d9e6ff" bold />;
    }

    return null;
  };

  return (
    <CardIncentivesContainer
      view={view}
      certified={vehicle.category == VehicleCategory.CERTIFIED}
      hasIncentives={incentives.count > 0}
    >
      {getCustomTags()}
    </CardIncentivesContainer>
  );
};

export default CardIncentives;
